export default "__VITE_ASSET__2621507f__"